import React, { useState } from 'react';

import { AbaFilterButtons, AbaFilterContent } from '../../../../components/develop-nilton-components/AbaFiltro';
import { FatoresFisAnual } from './FatoresFisAnual';
import { FatoresFisTrimestral } from './FatoresFisTrimestral';

export function FatoresFis({ tabType }:{tabType:number}) {
  const [tab, setTab] = useState(1);
  return (
    <div className="mt-3">
      <AbaFilterButtons
        useStateTab={[tab, setTab]}
        buttons={["Anual", "Trimestral"]}
      />
      <AbaFilterContent
        tab={tab}
        components={[
          <FatoresFisAnual tab={tab} tabType={tabType} />,
          <FatoresFisTrimestral tab={tab} tabType={tabType} />,
        ]}
      />
    </div>
  );
}
